import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";

export const discover = () => {
    const challenges = document.querySelector(".discover-challenges");
    const highlights = document.querySelector(".discover-highlights");

    challenges && challengesInit(challenges);
    highlights && highlightsInit(highlights);
};

const challengesInit = el => {
    const slider = el.querySelector(".discover-challenges__slider");
    const pagination = el.querySelector(".discover-challenges__pagination");
    const prevEl = el.querySelector(".discover-challenges__prev");
    const nextEl = el.querySelector(".discover-challenges__next");
    new Swiper(slider, {
        modules: [Navigation, Pagination],
        slidesPerView: "auto",
        spaceBetween: 15,
        navigation: {
            prevEl,
            nextEl,
        },
        pagination: {
            el: pagination,
            clickable: true,
        },
        breakpoints: {
            480: {
                spaceBetween: 30,
            },
        },
    });
};

const highlightsInit = el => {
    const slider = el.querySelector(".discover-highlights__slider");
    const pagination = el.querySelector(".discover-highlights__pagination");
    const prevEl = el.querySelector(".discover-highlights__prev");
    const nextEl = el.querySelector(".discover-highlights__next");

    new Swiper(slider, {
        modules: [Navigation, Pagination],
        slidesPerView: "auto",
        spaceBetween: 30,
        navigation: {
            prevEl,
            nextEl,
        },
        pagination: {
            el: pagination,
            clickable: true,
        },
    });
};
